export const EntityType = Object.freeze({
  Customer: 1,
  Account: 2,
  User: 6,
  PaymentInstrument: 10,
  TaxDocument: 160,
  Person: 170,
});
